// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rumKa7pcpf4kxyEhy1bM{min-width:0;max-width:100%;overflow:hidden}.wU4420MxHGgX8ZM2zaFs{cursor:pointer;min-width:0;max-width:100%;overflow:hidden}.pBWz2Z3ayPQgc8aT5W13{border-radius:6px;align-items:center;gap:6px;padding:4px 8px;display:inline-flex}.pBWz2Z3ayPQgc8aT5W13:hover{cursor:pointer;background:var(--background-primary-inverted-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nameCell": `rumKa7pcpf4kxyEhy1bM`,
	"secretCell": `wU4420MxHGgX8ZM2zaFs`,
	"tooltipCopyLabel": `pBWz2Z3ayPQgc8aT5W13`
};
export default ___CSS_LOADER_EXPORT___;
